import { useMemo } from "react";
import { useGetEmployeeDetailsQuery } from "../ReduxToolkit/api/employee";

interface UserData {
  id?: number;
}

interface Location {
  pathname: string;
}

const useFetchUserProfile = (userData: UserData, location: Location) => {
  const shouldFetchProfile = useMemo(() => {
    const pathsToAvoid = [
      "/login",
      "/register",
    ];
    const isInAvoidPath = pathsToAvoid.some((path) =>
      location.pathname.startsWith(path)
    );
    return userData?.id && !isInAvoidPath;
  }, [userData?.id, location.pathname]);

  const queryResult = useGetEmployeeDetailsQuery(String(userData?.id), {
    skip: !shouldFetchProfile, // don’t fetch on avoid paths
  });
  return queryResult; // returns { data, error, isLoading, refetch }
};

export default useFetchUserProfile;
